const normalizeRoles = roles => (Array.isArray(roles) ? roles : [])

function markKeapPartnerCatalog(catalog) {
  const hasProducts = ['centers', 'apps', 'oneTimeFees'].some(
    key => Array.isArray(catalog?.[key]) && catalog[key].length > 0,
  )
  if (!hasProducts) {
    throw new Error(
      'No Keap Partner plans were returned. Please try again before continuing.',
    )
  }

  // Client-only context: KP inventory is already role-scoped by app-type and
  // must retain the legacy KP availability rules in the shared Core Catalog.
  return {...catalog, catalogSource: 'keap-partner'}
}

/**
 * Retrieves the exact inventory shape used by the legacy KP11 1:1 catalog.
 * KP plans are country-specific; InfluencerOps additionally replaces the Keap
 * center group with its influencer inventory while retaining the KP base
 * catalog's non-Keap centers.
 */
export async function fetchKeapPartnerCatalog(
  client,
  {country = 'US', roles = [], linkType = '1:1'} = {},
) {
  const normalizedRoles = normalizeRoles(roles)
  const isInfluencerOps = normalizedRoles.includes('InfluencerOps')
  const appType = linkType === '1:many' ? 'kp1tomany' : 'kp1to1'
  const endpoint = `plans/5/v1/list?country=${encodeURIComponent(country)}`
  const request = appTypeValue =>
    client(endpoint, {headers: {'app-type': appTypeValue}})

  if (!isInfluencerOps || linkType === '1:many') {
    return markKeapPartnerCatalog(await request(appType))
  }

  const [baseCatalog, influencerCatalog] = await Promise.all([
    request(appType),
    request('influencerops'),
  ])
  const influencerKeapCenters = (influencerCatalog?.centers ?? []).filter(
    center => center.uigroup === 'Keap',
  )

  return markKeapPartnerCatalog({
    ...baseCatalog,
    centers: [
      ...(baseCatalog?.centers ?? []).filter(
        center => center.uigroup !== 'Keap',
      ),
      ...influencerKeapCenters,
    ],
  })
}
